export default "__VITE_ASSET__m6xgW2ME__"